import { useQuery } from '@tanstack/react-query'

import { isDevelopment } from '../../../lib/helpers/envHelpers'
import { QUERY_KEYS } from '../../../lib/queryKeys'
import companyUserIntegrationService from '../../../lib/services/companyUserIntegrationService'
import { INTEGRATION_SERVICE } from '../../../types/misc'

export function useNylasEmailCompanyUserIntegrationQuery() {
  return useQuery({
    queryKey: QUERY_KEYS.companyUserIntegrationByType(
      INTEGRATION_SERVICE.nylasEmail,
    ),
    queryFn: () => companyUserIntegrationService.getNylasEmailIntegration(),
    refetchOnWindowFocus: false,
    retry: isDevelopment() ? false : undefined,
    staleTime: 20000,
    throwOnError: false,
  })
}
